"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'NavList',
  props: {
    propsData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    navPadding: function navPadding() {
      if (!this.propsData.navPadding) {
        return '';
      }
      return "\n      ".concat(this.propsData.navPadding.pt || 0, "px \n      ").concat(this.propsData.navPadding.pr || 0, "px \n      ").concat(this.propsData.navPadding.pb || 0, "px \n      ").concat(this.propsData.navPadding.pl || 0, "px");
    }
  }
};